// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer_nW8Nu","container":"Footer_container_eFXHa","button":"Footer_button_xUOne","privacy":"Footer_privacy_CJtBU","email":"Footer_email_ImYvp"};